import { render, staticRenderFns } from "./GiftList.vue?vue&type=template&id=3c0c7cd4"
import script from "./GiftList.vue?vue&type=script&lang=js"
export * from "./GiftList.vue?vue&type=script&lang=js"
import style0 from "./GiftList.vue?vue&type=style&index=0&id=3c0c7cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports